import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/modules/shared/services/http/http.service';
import { HttpClient } from '@angular/common/http';
import { travelAuthorUrl, travelSummaryUrl, travelBookingUrl, travelApproveUrl, positionUrl, departmentUrl, travelItineraryUrl, travelRequestUrl, itineraryDeleteBookingUrl } from 'src/app/modules/shared/common/api';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class TravelService  extends HttpService{

   constructor(http: HttpClient) { 
    super('',http);
  }

  getFilter() {
    return this.get().map(res => {
      return res['data'];
    }); 
  }

  handleError(error){
    return throwError(error)
  }

  storeTravel(data) {
    return this.http.post(travelAuthorUrl, data).map((dataResponse) => {
      return dataResponse;
    });
  } 
 
  storeInfo(data) {
    return this.http.post(travelAuthorUrl+'/new', data).map((dataResponse) => {
      return dataResponse;
    });
  }
  
  updateInfo(id,data) {
    return this.http.put(travelAuthorUrl+'/new/'+id, data).map((dataResponse) => {
      return dataResponse;
    });
  }  
 
  storeIntinerary(data) {
    return this.http.post(travelItineraryUrl, data).map((dataResponse) => {
      return dataResponse;
    });
  } 

  updateItinerary(id,data) {
    return this.http.put(travelItineraryUrl+'/'+id, data).map((dataResponse) => {
      return dataResponse;
    });
  } 

  deleteItinerary(id,ta_id) {
    return this.http.delete(travelItineraryUrl + '/' + id +'?travel_request_id='+ta_id ).map((dataResponse) => {
      return dataResponse;
    });
  }
  
  storeSummary(data) {
    return this.http.post(travelSummaryUrl, data).map((dataResponse) => {
      return dataResponse;
    });
  }

  storeBooking(data) {
    return this.http.post(travelBookingUrl, data).map((dataResponse) => {
      return dataResponse;
    });
  }

  updateTravel(id, data) {
    return this.http.put(travelAuthorUrl + '/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
  }

  updateSummary(id, data) {
    return this.http.put(travelSummaryUrl + '/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
  }

  updateBooking(id, data) {
    return this.http.put(travelBookingUrl + '/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
  }

  updateStatus(id,data) {
    return this.http.put(travelAuthorUrl + '/status/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
  }

  deleteSummary(id) {
    return this.http.delete(travelSummaryUrl + '/' + id ).map((dataResponse) => {
      return dataResponse;
    });
  }

  deleteBooking(id) {
    return this.http.delete(travelBookingUrl + '/' + id ).map((dataResponse) => {
      return dataResponse;
    });
  }

  approverUpdateStatus(id,data) {
    return this.http.put(travelApproveUrl + '/status/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
  }

  getPosition() {
    return this.http.get(positionUrl).map((dataResponse) => {
      return dataResponse['data'];
    });
  }


  getDepartment() {
    return this.http.get(departmentUrl).map((dataResponse) => {
      return dataResponse['data'];
    });
  }

  // Version 1.5
  getRequestFilter() {
    return this.get().map(res => {
      return res['data'];
    }); 
  }

  storeRequestInfo(data) {
    return this.http.post(travelRequestUrl, data).map((dataResponse) => {
      return dataResponse;
    }).pipe(catchError(this.handleError))
  }

  updateRequestInfo(id, data) {
    return this.http.put(travelRequestUrl+'/'+id, data).map((dataResponse) => {
      return dataResponse;
    }).pipe(catchError(this.handleError))
  }

  deleteItineraryBooking(id) {
    return this.http.delete(itineraryDeleteBookingUrl+'/'+id).map((dataResponse) => {
      return dataResponse;
    });
  }
}
